import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Enterprise } from '../../../../../../../types/ProductFactory';
import CbeSearchInput from './CbeSearchInput';
import { Box } from '@wegroup/design-system';
import QuestionGroupActions from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupActions';
import QuestionGroupAssistantQuestion from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupAssistantQuestion';
import AdvisoryFlowMainContainer from '../../../ui/advisory-flow/components/app-shell/AdvisoryFlowMainContainer';
import QuestionTitle from '../../../../../../sales-conversation/src/components/legacy/questions/QuestionTitle';
import QuestionGroupBody from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupBody';
import QuestionGroupSubViewWrapper from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupSubViewWrapper';

interface Props {
  hasValue?: boolean;
  previousQuestionHandler: () => void;
  nextSubView: () => void;
  handleOnChange: (arg0: Enterprise | boolean) => void;
  onCantFind: () => void;
}

const CbeSearch: React.FC<React.PropsWithChildren<Props>> = ({
  hasValue,
  previousQuestionHandler,
  nextSubView,
  handleOnChange,
  onCantFind,
}) => {
  const { t } = useTranslation();

  const Question = () => (
    <QuestionGroupAssistantQuestion
      question={t(
        'Please provide us with the name or CBE number of the company',
      )}
      description={t(
        'When found, we are able to retrieve data about the company and automatically fill it in for you!',
      )}
    />
  );

  return (
    <AdvisoryFlowMainContainer>
      <Question />
      <QuestionGroupBody>
        <QuestionGroupSubViewWrapper>
          <Box width="100%" maxWidth="45rem">
            <StyledQuestionTitle>{t('CBE number')}:</StyledQuestionTitle>
            <CbeSearchInput
              handleOnChange={handleOnChange}
              onCantFind={onCantFind}
            />
          </Box>
        </QuestionGroupSubViewWrapper>
      </QuestionGroupBody>
      <QuestionGroupActions
        onBack={previousQuestionHandler}
        onContinue={nextSubView}
        disabledContinue={!hasValue}
      />
    </AdvisoryFlowMainContainer>
  );
};

const StyledQuestionTitle = styled(QuestionTitle)`
  width: 100%;
`;

export default CbeSearch;
